<template>
  <!-- #region template -->
  <b-container fluid class="m-0 p-0">
    <b-form @submit.prevent="submit" v-if="ready">
      <b-row>
        <b-col cols="12">
          <!-- TODO make a seperate settings page -->
          <!-- #region elements -->
          <b-card :body-class="card ? '' : 'p-0'" :class="card ? 'shadow-sm mb-4' : 'border-0 p-0'" v-for="(tab, index) in blueprint.form.tabs" :key="index">
            <template v-if="card" #header>
              <h6 class="m-0">{{ tab.label }}</h6>
            </template>
            <b-form-group>
              <b-row>
                <b-col :cols="card ? (tab.cols ? tab.cols : '4') : '12'">
                  <b-row>
                    <!-- #region elements -->
                    <b-col :cols="element.cols" v-for="(element, index) in tab.elements" :key="index">
                      <b-form-group :label="element.type != 'bool' ? element.label : ''" :label-for="element.key" :description="element.description">
                        <!-- file -->
                        <template v-if="element.type == 'file'">
                          <div style="position: relative; height: 150px; width: 150px; background-color: #f0f0f0; border-radius: 4px" class="border d-flex justify-content-center align-items-center">
                            <img :src="src[element.key]" style="height: 100%; max-width: 100%" alt="main" class="p-2" />
                            <div style="position: absolute; top: 5px; right: 5px">
                              <b-icon type="button" v-on:click="removeImage(element)" icon="x" font-scale="2" aria-hidden="true"></b-icon>
                            </div>
                          </div>
                          <b-button class="mt-3" style="width: 150px" variant="primary" @click="openMediaLibrary(element.key)">Choose File</b-button>
                        </template>
                        <!-- gallery -->
                        <template v-if="element.type == 'gallery'">
                          <div style="" class="gallery border d-flex justify-content-center align-items-center">
                            <div style="position: absolute; top: 5px; right: 5px">
                              <b-icon type="button" v-on:click="removeImage(element)" icon="x" font-scale="2" aria-hidden="true"></b-icon>
                            </div>
                            <div class="images">
                              <template v-for="(img, index) in document[element.key]">
                                <img :key="index" :src="img" style="height: 100%; max-width: 100%" alt="main" class="p-2" />
                              </template>
                            </div>
                          </div>
                          <b-button class="mt-3" style="width: 150px" variant="primary" @click="openMediaLibrary(element.key, true)">Choose File</b-button>
                        </template>
                        <!-- text -->
                        <template v-if="element.type == 'text'">
                          <div class="d-flex align-items-center">
                            <template v-if="element.prepend">
                              <div class="input-group-prepend" style="height: 33.5px">
                                <img class="input-group-text" :src="element.prepend" alt="" />
                              </div>
                            </template>
                            <b-form-input :disabled="element.disabled" autocomplete="off" :id="element.key" v-model="document[element.key]" :placeholder="element.placeholder" :required="element.required"></b-form-input>
                          </div>
                        </template>
                        <!-- url -->
                        <template v-if="element.type == 'url'">
                          <b-form-input :formatter="formatterURL" autocomplete="off" :id="element.key" v-model="document[element.key]" :placeholder="element.placeholder" :required="element.required"></b-form-input>
                          <template v-if="element.preview">
                            <a :href="element.preview.prefix + document[element.key] + element.preview.suffix" target="_blank">{{ element.preview.prefix }}{{ document[element.key] }}{{ element.preview.suffix }}</a>
                          </template>
                        </template>
                        <!-- email -->
                        <template v-if="element.type == 'email'">
                          <b-form-input autocomplete="off" type="email" :id="element.key" v-model="document[element.key]" :placeholder="element.placeholder" :required="element.required"></b-form-input>
                        </template>
                        <!-- tel -->
                        <template v-if="element.type == 'tel'">
                          <b-form-input autocomplete="off" type="tel" :id="element.key" v-model="document[element.key]" :placeholder="element.placeholder" :required="element.required"></b-form-input>
                        </template>
                        <!-- number -->
                        <template v-if="element.type == 'number'">
                          <b-form-input autocomplete="off" type="number" :id="element.key" v-model="document[element.key]" :placeholder="element.placeholder" :required="element.required"></b-form-input>
                        </template>
                        <!-- textarea -->
                        <template v-if="element.type == 'textarea'">
                          <b-form-textarea autocomplete="off" :id="element.name" v-model="document[element.key]" :placeholder="element.placeholder" :rows="element.rows" :max-rows="element['max-rows']"></b-form-textarea>
                        </template>
                        <!-- bool -->
                        <template v-if="element.type == 'bool'">
                          <b-row>
                            <b-col cols="6">
                              {{ element.label }}
                            </b-col>
                            <b-col cols="6">
                              <b-form-checkbox autocomplete="off" :id="element.name" v-model="document[element.key]" :name="element.key" switch></b-form-checkbox>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- select -->
                        <template v-if="element.type == 'select'">
                          <eSelect :value="document[element.key]" :element="element" @input="document[element.key] = $event" />
                        </template>
                        <!-- multiselect -->
                        <template v-if="element.type == 'multiselect'">
                          <eMultiSelect autocomplete="off" :value="document[element.key]" @input="document[element.key] = $event" :element="element" :blueprint="element.blueprint" />
                        </template>
                        <!-- country -->
                        <template v-if="element.type == 'country'">
                          <b-form-select autocomplete="off" v-model="document[element.key]" :options="Countries" :multiple="element.multiple" :select-size="element['select-size']" :required="element.required">
                            <template #first>
                              <b-form-select-option :value="null" disabled>Country</b-form-select-option>
                            </template>
                          </b-form-select>
                        </template>
                        <!-- cardinal -->
                        <template v-if="element.type == 'cardinal'">
                          <b-form-select autocomplete="off" v-model="document[element.key]" :options="Cardinals" :multiple="element.multiple" :select-size="element['select-size']" :required="element.required">
                            <template #first>
                              <b-form-select-option :value="null" disabled>Cardinal</b-form-select-option>
                            </template>
                          </b-form-select>
                        </template>
                        <!-- date -->
                        <template v-if="element.type == 'date'">
                          <b-form-datepicker autocomplete="off" :id="element.name" v-model="document[element.key]" class="mb-2"></b-form-datepicker>
                        </template>
                        <!-- html -->
                        <template v-if="element.type == 'html'">
                          <CodeEditor :languages="[['html', 'HTML']]" width="100%" height="500px" border_radius="0.25rem" v-model="document[element.key]" class="mb-2"></CodeEditor>
                        </template>
                        <!-- css -->
                        <template v-if="element.type == 'css'">
                          <CodeEditor :languages="[['css', 'CSS']]" width="100%" height="500px" border_radius="0.25rem" v-model="document[element.key]" class="mb-2"></CodeEditor>
                        </template>
                        <!-- javascript -->
                        <template v-if="element.type == 'javascript'">
                          <CodeEditor :languages="[['javascript', 'JS']]" width="100%" height="500px" border_radius="0.25rem" v-model="document[element.key]" class="mb-2"></CodeEditor>
                        </template>
                      </b-form-group>
                    </b-col>
                    <!-- #endregion -->
                  </b-row>
                </b-col>
              </b-row>
            </b-form-group>
          </b-card>
          <!-- #endregion -->
        </b-col>
      </b-row>
      <div class="d-flex justify-content-between align-items-center" v-if="!noFooter">
        <template v-if="type == 'add'">
          <b-form-checkbox v-model="another" name="another" switch> Create another </b-form-checkbox>
        </template>
        <div>
          <b-button type="submit" variant="primary" :disabled="busy">
            <template v-if="!busy"> Save </template>
            <template v-else> <b-spinner small type="grow"></b-spinner> Saving... </template>
          </b-button>
          <b-button class="ml-2" v-if="type == 'edit'" v-on:click="copy" variant="primary" :disabled="busy">Copy</b-button>
          <b-button class="ml-2" v-on:click="$emit('close')" variant="primary" :disabled="busy">Cancel</b-button>
        </div>
        <!--<template v-if="type == 'edit'">
          <b-button variant="danger" class="ml-2" v-on:click="$emit('deleteEntry')">Delete</b-button>
        </template> -->
      </div>
      <b-modal hide-footer ref="file-modal" size="xl" title="Media Library">
        <template v-if="mediaLibrary.multiple">
          <MediaLibrary :multiple="true" v-on:select="mediaSelect($event, mediaLibrary.key)" />
        </template>
        <template v-else>
          <MediaLibrary v-on:select="mediaSelect($event, mediaLibrary.key)" />
        </template>
      </b-modal>
    </b-form>
  </b-container>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import { mapActions } from 'vuex'
import { Countries, Cardinals, getDocumentReference } from '@/utils'
import eSelect from '@/components/elements/eSelect'
import eMultiSelect from '@/components/elements/eMultiSelect'
// ? should this be wrapped in a widget instead?
import MediaLibrary from '@/views/extensions/MediaLibrary.vue'
import CodeEditor from 'simple-code-editor'
// #endregion

// #region export
export default {
  name: 'cForm',
  components: {
    MediaLibrary,
    eSelect,
    eMultiSelect,
    CodeEditor,
  },
  props: {
    blueprint: {
      type: Object,
      required: true,
    },
    init: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
    noFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    card: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      document: {},
      src: {},
      mediaLibrary: {
        key: undefined,
        multiple: false,
      },
      another: false,
      ready: false,
      document_: {},
      Countries,
      Cardinals,
      busy: true,
    }
  },
  created() {
    if (this.init._reference) {
      this['firestore/getDoc']({
        path: this.init._reference.path,
      }).then((documentSnapshot) => {
        this.document = documentSnapshot
        console.log('FORM just opened', JSON.parse(JSON.stringify(this.init._reference)))
        // this.document._reference = this.init.reference
        //   return this.populateDocument({
        //     blueprint: this.blueprint,
        //     document: this.document
        //   })
        // })
        // .then((value) => {
        //   this.document = value;
        // console.log("STRING", this.document.product.path)
        // this.document.product = this.document.product.path
        this.setup()
      })
    } else {
      this.document = { ...this.init }
      this.setup()
    }
  },
  methods: {
    ...mapActions(['getDocument', 'populateDocument', 'getDoc', 'firestore/doc', 'firestore/getDoc', 'firestore/updateDoc', 'firestore/addDoc']),
    /**
     * Initialize the form
     */
    setup() {
      this.blueprint.form.tabs.forEach((tab) => {
        tab.elements.forEach((element) => {
          if (element.type == 'file') {
            this.$set(this.src, [element.key], this.document[element.key] || 'https://via.placeholder.com/150x150')
          }
          if (element.type == 'select' || element.type == 'multiselect') {
            if (element.collection) {
              if (element.type == 'multiselect') {
                this.document[element.key] = this.document[element.key].map((value) => {
                  return value.path
                })
              } else {
                console.log('what', this.document, element.key, this.document[element.key])
                this.document[element.key] = this.document[element.key].path || ''
              }
            }
          }
        })
      })
      this.ready = true
      this.busy = false
    },
    /**
     * Removes an image from the given field.
     * @param {object} element The element belonging to the field.
     */
    removeImage(element) {
      this.document[element.key] = element.default
      this.$set(this.src, [element.key], 'https://via.placeholder.com/150x150')
    },
    openMediaLibrary(key, multiple) {
      this.mediaLibrary.key = key
      this.mediaLibrary.multiple = multiple
      this.$refs['file-modal'].toggle()
    },
    mediaSelect(file, key) {
      if (this.mediaLibrary.multiple) {
        this.document[key] = file
        this.$refs['file-modal'].toggle()
      } else {
        this.src[key] = file.src
        this.document[key] = file.src
        this.$refs['file-modal'].toggle()
      }
    },
    formatterURL(value) {
      return value.replace(/\s+/g, '-').toLowerCase()
    },
    /**
     * Makes a copy of the current document.
     */
    copy() {
      delete this.document._reference
      this.submit()
    },
    /**
     * Submits the current document.
     */
    submit() {
      let _document = { ...this.document }
      this.blueprint.form.tabs.forEach((tab) => {
        tab.elements.forEach((element) => {
          if (element.type == 'select' || element.type == 'multiselect') {
            if (element.collection) {
              if (element.multiple) {
                _document[element.key] = _document[element.key].map((value) => {
                  return getDocumentReference({ path: value })
                })
              } else {
                _document[element.key] = getDocumentReference({ path: _document[element.key] })
              }
            }
          }
        })
      })
      if (this.document._reference) {
        delete _document._reference
        this['firestore/updateDoc']({
          data: _document,
          path: this.document._reference.path,
        })
          .then(() => {
            this.$emit('close')
          })
          .catch((err) => {
            console.log('err', err)
            // TODO Task: Error Handling (firebase error) - Comment: Create an error handling view, that expects props, and render it here
          })
      } else {
        this['firestore/addDoc']({
          data: _document,
          path: this.blueprint.collection,
        })
          .then(() => {
            if (!this.another) {
              this.$emit('close')
            }
          })
          .catch((err) => {
            console.log(err)
            // TODO Task: Error Handling (firebase error) - Comment: Create an error handling view, that expects props, and render it here
          })
      }
    },
  },
}
// #endregion
// #endregion
</script>

<style lang="scss">
.card-header {
  background-color: inherit;
}
.gallery {
  position: relative;
  height: 150px;
  justify-content: flex-start !important;
  background-color: #f0f0f0;
  border-radius: 4px;
  .images {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    overflow-x: scroll;
  }
}
</style>
